/* eslint-disable react/jsx-props-no-spreading */
import React, { memo } from "react";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { MdQuestionMark } from "react-icons/md";
import Swal from "sweetalert2";

const Services = () => {
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext(); // Access form context

  const watchFieldArray = watch("extra_service");
  const extraServices = watch("extra_services");

  const { fields, append, remove } = useFieldArray({
    control, // Pass the control object from `useForm`
    name: "extra_service", // Name of the field array
  });

  // Combine field metadata and watched values for each dependant
  const extraServiceList = fields.map((field, index) => {
    return {
      ...field, // Include field metadata from `useFieldArray`
      ...watchFieldArray?.[index], // Include watched values from `watch`
    };
  });
  return (
    <div className="mt-4">
      <h4 className="mb-2 text-2xl flex items-center font-bold">
        Extra Service
        <MdQuestionMark
          onClick={() =>
            Swal.fire({
              text: `This section allows you to define additional charges for specific services outside of your regular nightly rate. For example, you may want to offer extra amenities, catering services, or special requests that come with an added cost. Some Hosts may also offer discounted rates or additional services during specific seasons or events to enhance the guest experience.`,
              icon: "question",
            })
          }
          style={{
            color: "#fff",
            background: "#8ec639",
            borderRadius: "50%",
            fontWeight: "bold",
            fontSize: "1.2rem",
            marginLeft: "8px",
            boxShadow: "0 0 8px 2px #8ec639, 0 0 0 3px #c6f6d5",
            border: "2px solid #8ec639",
            cursor: "pointer",
            padding: "2px",
            animation: "pulse-glow 1.2s infinite alternate",
          }}
          className="focus:outline-none focus:ring-2 focus:ring-[#8ec639]"
          title="Info."
        />
      </h4>

      <div className="mt-4 grid grid-cols-1">
        <div className="col-span-1">
          <label
            htmlFor="extra_services"
            className="mb-1 block text-sm font-medium text-gray-700"
          >
            Extra services?
          </label>
          <Controller
            name="extra_services"
            control={control}
            render={({ field: { onChange, value } }) => (
              <select
                id="extra_services"
                className={`w-full rounded-md border p-3  ${
                  errors?.extra_services?.message
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                value={value}
                onChange={onChange}
              >
                <option value={1}>Yes</option>
                <option value={0}>No</option>
              </select>
            )}
          />
          {errors?.extra_services?.message && (
            <p className="mt-1 text-sm text-red-500">
              {errors?.extra_services?.message}
            </p>
          )}
          {!errors?.extra_services?.message && (
            <p className="mt-1 text-sm text-gray-500">
              Do you have any extra services you would like to offer?
            </p>
          )}
        </div>
      </div>
      {extraServices == 1 &&
        extraServiceList?.map((service, index) => {
          return (
            <div
              key={`${service?.id}-${index}`}
              className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-4"
              id="extra_service"
            >
              <div className="col-span-1">
                <label
                  htmlFor={`extra_service[${index}].name`}
                  className="mb-1 block text-sm font-medium text-gray-700"
                >
                  Name
                </label>
                <Controller
                  name={`extra_service[${index}].name`}
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <input
                      id={`extra_service[${index}].name`}
                      type="text"
                      className={`w-full rounded-md border px-4 py-3  ${
                        errors.extra_service?.[index]?.name?.message
                          ? "border-red-500"
                          : "border-gray-300"
                      }`}
                      placeholder="e.g. Catering"
                      value={value}
                      onChange={onChange}
                    />
                  )}
                />
                {errors.extra_service?.[index]?.name?.message && (
                  <p className="mt-1 text-sm text-red-500">
                    {errors.extra_service?.[index]?.name?.message}
                  </p>
                )}
              </div>
              <div className="col-span-1">
                <label
                  htmlFor={`extra_service[${index}].price`}
                  className="mb-1 block text-sm font-medium text-gray-700"
                >
                  Price
                </label>
                <Controller
                  name={`extra_service[${index}].price`}
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <input
                      id={`extra_service[${index}].price`}
                      type="number"
                      className={`w-full rounded-md border px-4 py-3  ${
                        errors.extra_service?.[index]?.price?.message
                          ? "border-red-500"
                          : "border-gray-300"
                      }`}
                      placeholder="e.g. 50"
                      value={value}
                      onChange={onChange}
                    />
                  )}
                />
                {errors.extra_service?.[index]?.price?.message && (
                  <p className="mt-1 text-sm text-red-500">
                    {errors.extra_service?.[index]?.price?.message}
                  </p>
                )}
              </div>
              <div className="col-span-1">
                <label
                  htmlFor={`extra_service[${index}].type`}
                  className="mb-1 block text-sm font-medium text-gray-700"
                >
                  Type
                </label>
                <Controller
                  name={`extra_service[${index}].type`}
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <select
                      id={`extra_service[${index}].type`}
                      className={`w-full rounded-md border px-4 py-3  ${
                        errors.extra_service?.[index]?.type?.message
                          ? "border-red-500"
                          : "border-gray-300"
                      }`}
                      value={value}
                      onChange={onChange}
                    >
                      <option value="">Type</option>
                      <option value="Single Fee">Single Fee</option>
                      <option value="Per Night">Per Night</option>
                      <option value="Per Guest">Per Guest</option>
                      <option value="Per Night Per Guest">
                        Per Night Per Guest
                      </option>
                    </select>
                  )}
                />
                {errors.extra_service?.[index]?.type?.message && (
                  <p className="mt-1 text-sm text-red-500">
                    {errors.extra_service?.[index]?.type?.message}
                  </p>
                )}
              </div>
              <div className="col-span-1">
                <label
                  htmlFor={`extra_service[${index}].quantity`}
                  className="mb-1 block text-sm font-medium text-gray-700"
                >
                  Quantity Available
                </label>
                <Controller
                  name={`extra_service[${index}].quantity`}
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <input
                      id={`extra_service[${index}].quantity`}
                      type="number"
                      className={`w-full rounded-md border px-4 py-3  ${
                        errors.extra_service?.[index]?.quantity?.message
                          ? "border-red-500"
                          : "border-gray-300"
                      }`}
                      placeholder="e.g. 1"
                      value={value}
                      onChange={onChange}
                    />
                  )}
                />
                {errors.extra_service?.[index]?.quantity?.message && (
                  <p className="mt-1 text-sm text-red-500">
                    {errors.extra_service?.[index]?.quantity?.message}
                  </p>
                )}
              </div>
              {extraServiceList?.length > 1 && (
                <div className="col-span-4 flex justify-end">
                  <button
                    type="button"
                    className="rounded-md border border-red-500 bg-white px-4 py-2 text-sm font-medium text-red-500 shadow-sm hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                    onClick={() => remove(index)}
                  >
                    Remove service
                  </button>
                </div>
              )}
            </div>
          );
        })}

      {extraServices === 1 && (
        <button
          type="button"
          className="mt-2 rounded-md border border-indigo-500 bg-white px-4 py-2 text-sm font-medium text-indigo-500 shadow-sm hover:bg-indigo-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          onClick={() => {
            append({
              name: "",
              price: "",
              type: "",
              quantity: "",
            });
          }}
        >
          Add new service
        </button>
      )}
    </div>
  );
};

export default memo(Services);
